<div class="switch" [class.small]="small" [class.selected]="value" (click)="readonly || toggle()">
  <div class="ball"></div>
</div>
